<template>
  <section class="ScholarshipSearchResults">
    <h2 v-if="isTestPage">Scholarship Search is coming soon</h2>
    <h2 v-else :class="{ Blink: loading }">Redirecting to Scholarship Search...</h2>
  </section>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useSearchTypeRedirect } from "@app/composables/useSearchTypeRedirect";
import { isPrefixedScholarshipPath } from "@app/utils/portal-type-base-path";
import { SearchType } from "@domain/enums/SearchType";

// Under the route prefix this is the scholarship test page; otherwise redirect to the legacy page
const isTestPage = isPrefixedScholarshipPath(useRouter().currentRoute.value.path);
const { loading } = isTestPage ? { loading: ref(false) } : useSearchTypeRedirect(SearchType.SCHOLARSHIP_SEARCH);
</script>

<style scoped lang="scss">
    .ScholarshipSearchResults {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        @include PaddingAreas(0.25, 0);
    }
    .Blink {
        animation: blink-animation 1s linear infinite;
    }

    @keyframes blink-animation {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
    }
</style>